import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import Layout from '@/views/Layout';


export const constantRoutes = [
    {
        path: '/login',
        component: () => import('@/views/Login/index'),
        hidden: true
    },

    {
        path: '',
        component: Layout,
        children: [
            {
                path: '',
                component: () => import('@/views/Index/index'),
                name: 'Index',
                meta: {title: '首页', icon: 'dashboard', affix: true}
            },
        ]
 
    },
    {
        path: '/Index',
        component: Layout,
        children: [
            {
                path: '',
                component: () => import('@/views/Index/index'),
                name: 'Index',
                meta: {title: '首页', icon: 'dashboard', affix: true}
            },
        ]
 
    },
   
   
    {
        path: '/WorkSheet',
        component: Layout,
        children: [
            {
                path: 'Index/:menuModuleId',
                component: () => import('@/views/WorkSheet/Index'),
                name: 'WorkSheet',
                props: true,
                meta: {title: '工单管理', icon: 'dashboard', affix: true}
            },
            {
                path: 'SheetViewParent/:Id',
                component: () => import('@/views/WorkSheet/SheetViewParent'),
                name: 'SheetViewParent',
                props: true,
                meta: {title: '跟进工单', icon: 'dashboard', affix: true}
            },
            {
                path: 'EditWorkSheet/:Id',
                component: () => import('@/views/WorkSheet/WorkSheetEdit'),
                name: 'EditWorkSheet',
                props: true,
                meta: {title: '查看/编辑工单', icon: 'dashboard', affix: true}
            },
            {
                path: 'Advance',
                component: () => import('@/views/WorkSheet/Advance/Index'),
                name: 'WorkSheet',
                props: true,
                meta: {title: '高级功能', icon: 'dashboard', affix: true}
            },
            
        ]
    }, 
    {
        path: '/Renew',
        component: Layout,
        children: [
            {
                path: 'Import',
                component: () => import('@/views/Renew/Import'),
                name: 'Import',
                props: true,
                meta: {title: '续约订单导入', icon: 'dashboard', affix: true}
            },
            {
                path: 'Do',
                component: () => import('@/views/Renew/Do'),
                name: 'Do',
                props: true,
                meta: {title: '续约执行', icon: 'dashboard', affix: true}
            },
          
        ]
    }, 
    {
        path: '/ZC',
        component: Layout,
        children: [
            {
                path: 'Client',
                component: () => import('@/views/ZC/Client'),
                name: 'Client',
                props: true,
                meta: {title: '客户信息', icon: 'dashboard', affix: true}
            },
            {
                path: 'Todo',
                component: () => import('@/views/ZC/Todo'),
                name: 'Todo',
                props: true,
                meta: {title: '服务管理', icon: 'dashboard', affix: true}
            },
            {
                path: 'AllTask',
                component: () => import('@/views/ZC/AllTask'),
                name: 'AllTask',
                props: true,
                meta: {title: '任务一览', icon: 'dashboard', affix: true}
            },
            {
                path: 'Agent',
                component: () => import('@/views/ZC/Agent'),
                name: 'Agent',
                props: true,
                meta: {title: '代理商信息', icon: 'dashboard', affix: true}
            },
            {
                path: 'Analysis',
                component: () => import('@/views/ZC/Analysis'),
                name: 'Analysis',
                props: true,
                meta: {title: '服务分析', icon: 'dashboard', affix: true}
            },
            {
                path: 'Order',
                component: () => import('@/views/ZC/Order'),
                name: 'Order',
                props: true,
                meta: {title: '订单信息', icon: 'dashboard', affix: true}
            },
            {
                path: 'Order',
                component: () => import('@/views/ZC/Order'),
                name: 'Order',
                props: true,
                meta: {title: '订单信息', icon: 'dashboard', affix: true}
            },
            {
                path: 'Train',
                component: () => import('@/views/ZC/Train'),
                name: 'Train',
                props: true,
                meta: {title: '培训管理', icon: 'dashboard', affix: true}
            },
            {
                path: 'Alert',
                component: () => import('@/views/ZC/Alert'),
                name: 'Alert',
                props: true,
                meta: {title: '预警服务', icon: 'dashboard', affix: true}
            },
        ]
    }, 
    {
        path: '/Survey',
        component: Layout,
        children: [
            {
                path: 'index',
                component: () => import('@/views/Survey/index'),
                name: 'index',
                meta: {title: '满意度分析', icon: 'dashboard', affix: true}
            },
           
        ]
    },

    {
        path: '/BD',
        component: Layout,
        children: [
            {
                path: 'Distributor',
                component: () => import('@/views/Distributor/index'),
                name: 'Distributor',
                meta: {title: '经销商列表', icon: 'dashboard', affix: true}
            },
            {
                path: 'DistributorDetail/:distributorCode',
                component: () => import('@/views/Distributor/DistributorDetail'),
                name: 'DistributorDetail',
                props: true,
                meta: {title: '查看/编辑经销商', icon: 'dashboard', affix: true}
            },
            {
                path: 'FinalUser',
                component: () => import('@/views/FinalUser/index'),
                name: 'FinalUser',
                meta: {title: '终端用户列表', icon: 'dashboard', affix: true}
            },
            {
                path: 'CallLog',
                component: () => import('@/views/CallLog/index'),
                name: 'CallLog',
                meta: {title: '通话记录', icon: 'dashboard', affix: true}
            },
            {
                path: 'EmailLog',
                component: () => import('@/views/EmailLog/index'),
                name: 'EmailLog',
                meta: {title: '邮件记录', icon: 'dashboard', affix: true}
            },
            {
                path: 'Report',
                component: () => import('@/views/Report/index'),
                name: 'Report',
                meta: {title: '数据报告', icon: 'dashboard', affix: true}
            },
            
            // {
            //     path: 'EditEmail/:Id',
            //     component: () => import('@/views/EmailLog/editDialog'),
            //     name: 'EditEmail',
            //     props: true,
            //     meta: {title: '查看/编辑邮件', icon: 'dashboard', affix: true}
            // },
        ]
    },

    {
        path: '/Analisys',
        component: Layout,
        children: [
            {
                path: 'Screen',
                component: () => import('@/views/Analisys/Screen'),
                name: 'Screen',
                meta: {title: '可视化大屏', icon: 'dashboard', affix: true}
            },

        ]
    },
    {
        path: '/Info',
        component: Layout,
        children: [
            {
                path: 'Index',
                component: () => import('@/views/Info/Index'),
                name: 'Index',
                meta: {title: '知识库', icon: 'dashboard', affix: true}
            },

        ]
    },


    {
        path: '/System',
        component: Layout,
        children: [

            {
                path: 'Account',
                component: () => import('@/views/System/Account/index'),
                name: 'Account',
                meta: {title: '账号管理', icon: 'dashboard', affix: true}
            },
            {
                path: 'Role',
                component: () => import('@/views/System/Role/index'),
                name: 'Role',
                meta: {title: '角色管理', icon: 'dashboard', affix: true}
            },
            
            {
                path: 'SysUser',
                component: () => import('@/views/System/SysUser/index'),
                name: 'SysUser',
                meta: {title: '系统用户管理', icon: 'dashboard', affix: true}
            },
            {
                path: 'Setting',
                component: () => import('@/views/System/Setting/index'),
                name: 'Setting',
                redirect: 'Setting/Module',
                meta: {title: '系统设置'},
                    children: [
                        {
                            path: 'Module',
                            component: () => import('@/views/System/Setting/Module/index'),
                            name: 'Setting-Module',
                            meta: {title: '模块设置', icon: 'dashboard', affix: true}
                        },
                        {
                            path: 'Category',
                            component: () => import('@/views/System/Setting/Category/index'),
                            name: 'Setting-Category',
                            meta: {title: '产品分类管理', icon: 'dashboard', affix: true}
                        },  
                        {
                            path: 'Dictionary',
                            component: () => import('@/views/System/Setting/Dictionary/index'),
                            name: 'Setting-Dictionary',
                            meta: {title: '数据字典', icon: 'dashboard', affix: true}
                        },                         
                    ]

            },
        ]
    },

   

    {
        path: '/find-password',
        component: () => import('@/views/FindPassword/index'),
        hidden: true
    },
    {
        path: '/reset-password',
        component: () => import('@/views/ResetPassword/index'),
        hidden: true
    },
 
]

const createRouter = () => new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({y: 0}),
    routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // reset router
}

export default router